import confetti from 'canvas-confetti';

/** Fire a confetti burst + two side firework cannons. Returns a cleanup fn. */
export function fireSessionConfetti(): () => void {
  // Central shower
  confetti({
    particleCount: 120,
    spread: 70,
    origin: { x: 0.5, y: 0.55 },
  });

  // Left cannon
  const t1 = setTimeout(() => {
    confetti({
      particleCount: 60,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.65 },
    });
  }, 200);

  // Right cannon
  const t2 = setTimeout(() => {
    confetti({
      particleCount: 60,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.65 },
    });
  }, 400);

  return () => { clearTimeout(t1); clearTimeout(t2); };
}
